export default __webpack_public_path__ + "static/media/evcharger5.7f6d2efc.jpg";